import(/* webpackMode: "eager", webpackExports: ["LoginPageClient"] */ "/Users/barath/code/chain-zen/apps/web-app/src/app/(auth)/login/_components/login-page-client.tsx");
